import { render, staticRenderFns } from "./EnterprisesMenu.vue?vue&type=template&id=a675d028&scoped=true&"
import script from "./EnterprisesMenu.vue?vue&type=script&lang=js&"
export * from "./EnterprisesMenu.vue?vue&type=script&lang=js&"
import style0 from "./EnterprisesMenu.vue?vue&type=style&index=0&id=a675d028&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a675d028",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VDivider,VFlex,VIcon,VLayout,VListItem,VRow,VTooltip})
